import {createContext, PropsWithChildren, useState} from "react";

interface ZendeskMessengerContext {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const DEFAULT_VALUE: ZendeskMessengerContext = {
  isOpen: false,
  open: () => {},
  close: () => {},
};

export const ZendeskMessengerContext = createContext<ZendeskMessengerContext>(DEFAULT_VALUE);

export const ZendeskMessengerProvider = ({children}: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ZendeskMessengerContext.Provider value={{isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false)}}>
      {children}
    </ZendeskMessengerContext.Provider>
  );
};
